import {IconBox, Typography} from '@sollapay/ui/components';

import type {IconName} from '@sollapay/ui';
import type {IconBoxTone} from '@sollapay/ui/components';
import type {ReactNode} from 'react';

export type BreakdownRowTone = Exclude<IconBoxTone, 'brand'> | keyof typeof OUTLINED_TONE_CONFIG;

export interface BreakdownRowProps {
  icon: IconName;
  tone: BreakdownRowTone;
  title: string;
  subtitle?: string;
  amount: ReactNode;
}

export function BreakdownRow({icon, tone, title, subtitle, amount}: BreakdownRowProps) {
  const toneProps = isOutlinedTone(tone)
    ? {
        className: OUTLINED_TONE_CONFIG[tone].tile,
        iconClassName: OUTLINED_TONE_CONFIG[tone].icon
      }
    : {tone};

  return (
    <div data-slot="balance-breakdown-row" className="flex w-full items-start gap-3">
      <IconBox icon={icon} size="sm" variant="tertiary" {...toneProps} />
      <div className="flex min-w-0 flex-1 flex-col items-start gap-0.5">
        <Typography>{title}</Typography>
        {subtitle ? (
          <Typography size="xs" color="tertiary">
            {subtitle}
          </Typography>
        ) : null}
      </div>
      {amount}
    </div>
  );
}

const OUTLINED_TONE_CONFIG = {
  reserved: {tile: 'border border-border-warning bg-background-surface', icon: 'text-text-warning'},
  pending: {
    tile: 'border border-dashed border-border bg-background-surface',
    icon: 'text-fg-tertiary'
  }
} as const;

function isOutlinedTone(tone: BreakdownRowTone): tone is keyof typeof OUTLINED_TONE_CONFIG {
  return tone in OUTLINED_TONE_CONFIG;
}
